const USER_KEY = 'MP_CRM_APP_USER';
const USER_SESION_STATE_KEY = 'APP_nombre_app_CURRENT_ESTADO_SESION';

const setUser = (datos) => {
    localStorage.setItem(USER_KEY, JSON.stringify(datos));
}

const getUser = () => {
    return JSON.parse(localStorage.getItem(USER_KEY));
}

const deleteUser = () => {
    localStorage.removeItem(USER_KEY);
}

const isUserAdmin = () => {
    const user = getUser();
    if (user) {
        const userRole = user.rolePermiso.find(x => x.role === '');
        return (userRole) ? true : false;
    }
    return false;
}


const setEstadoSesionUsuario = (estadoSesion) => {
    localStorage.setItem(USER_SESION_STATE_KEY, JSON.stringify(estadoSesion));
}

const getEstadoSesion = () => {
    const datos = localStorage.getItem(USER_SESION_STATE_KEY);
    if(datos)
        return JSON.parse(localStorage.getItem(USER_SESION_STATE_KEY));
    else 
        return {descripcion: '', color: '', id: ''}
}

export default {
    setUser,
    getUser,
    deleteUser,
    isUserAdmin,
    setEstadoSesionUsuario,
    getEstadoSesion
}